module.exports = __webpack_public_path__ + "static/media/durability.32022cd2.svg";